export interface ILogo {
  src: string;
  alt: string;
}
export interface IConfig {
  logos: ILogo[];
}
export const config: IConfig = {
  logos: [
      {
        src: process.env.PUBLIC_DIR + '/images/companies-logo/amocrm.svg',
        alt: 'AmoCRMIcon'
      },
      {
        src: process.env.PUBLIC_DIR + '/images/companies-logo/getcourse.svg',
        alt: 'GETCOURSEIcon'
      },
      {
        src: process.env.PUBLIC_DIR + '/images/companies-logo/payze.svg',
        alt: 'PAYZEIcon'
      },
      {
        src: process.env.PUBLIC_DIR + '/images/companies-logo/7mediagroup.svg',
        alt: '7MEDIAIcon'
      },
      {
        src: process.env.PUBLIC_DIR + '/images/companies-logo/ic.svg',
        alt: 'ICIcon'
      },
      {
        src: process.env.PUBLIC_DIR + '/images/companies-logo/hm.svg',
        alt: 'HOSTMASTERIcon'
      },
      {
        src: process.env.PUBLIC_DIR + '/images/companies-logo/juba.svg',
        alt: 'JUBAIcon'
      },
      {
        src: process.env.PUBLIC_DIR + '/images/companies-logo/upsoft.svg',
        alt: 'UPSOFTIcon'
      },
      {
        src: process.env.PUBLIC_DIR + '/images/companies-logo/bosch.svg',
        alt: 'BOSCHIcon'
      },
      {
        src: process.env.PUBLIC_DIR + '/images/companies-logo/midea.svg',
        alt: 'MIDEAIcon'
      },
      {
        src: process.env.PUBLIC_DIR + '/images/companies-logo/alfakom.svg',
        alt: 'ALFAKOMIcon'
      },
      {
        src: process.env.PUBLIC_DIR + '/images/companies-logo/ita.svg',
        alt: 'ITAIcon'
      },
      {
        src: process.env.PUBLIC_DIR + '/images/companies-logo/inter-nation.svg',
        alt: 'INTERNAIONIcon'
      },
      {
        src: process.env.PUBLIC_DIR + '/images/companies-logo/proweb.svg',
        alt: 'PROWEBIcon'
      },
      {
        src: process.env.PUBLIC_DIR + '/images/companies-logo/mediva.svg',
        alt: 'MEDIVAIcon'
      },
      {
        src: process.env.PUBLIC_DIR + '/images/companies-logo/greenpark.svg',
        alt: 'GREENPARKIcon'
      },
      {
        src: process.env.PUBLIC_DIR + '/images/companies-logo/chimgan-hills.svg',
        alt: 'CHIMGANHILLSIcon'
      },
      {
        src: process.env.PUBLIC_DIR + '/images/companies-logo/high-town-city.svg',
        alt: 'HIGHTOWNCITYIcon'
      },
      {
        src: process.env.PUBLIC_DIR + '/images/companies-logo/amirsoy.svg',
        alt: 'AMIRSOYIcon'
      },
      {
        src: process.env.PUBLIC_DIR + '/images/companies-logo/easy-booking.svg',
        alt: 'EASYBOOKINGIcon'
      },
      {
        src: process.env.PUBLIC_DIR + '/images/companies-logo/evos.svg',
        alt: 'EVOSIcon'
      },
      {
        src: process.env.PUBLIC_DIR + '/images/companies-logo/quadro.svg',
        alt: 'QUADROIcon'
      },
      {
        src: process.env.PUBLIC_DIR + '/images/companies-logo/maxway.svg',
        alt: 'MAXWAYIcon'
      },
      {
        src: process.env.PUBLIC_DIR + '/images/companies-logo/evakor.svg',
        alt: 'EVAKORIcon'
      },
      {
        src: process.env.PUBLIC_DIR + '/images/companies-logo/castrol.svg',
        alt: 'CASTROLIcon'
      },
      {
        src: process.env.PUBLIC_DIR + '/images/companies-logo/hyundai.svg',
        alt: 'HYUNDAIIcon'
      },
      {
        src: process.env.PUBLIC_DIR + '/images/companies-logo/chery.svg',
        alt: 'CHERYIcon'
      },
      {
        src: process.env.PUBLIC_DIR + '/images/companies-logo/premium-auto.svg',
        alt: 'PREMIUMAUTOIcon'
      },
      {
        src: process.env.PUBLIC_DIR + '/images/companies-logo/haval.svg',
        alt: 'HAVALIcon'
      },
      {
        src: process.env.PUBLIC_DIR + '/images/companies-logo/faw.svg',
        alt: 'FAWTRUCKSIcon'
      },
  ]
}